// @flow

"use strict";

/**
 * フレーム外からフレーム内へデータを渡すDTO
 */
export default class OuterToInnerDto {
  constructor(widgetId: string, url: string, referer: string, deviceCode: number, uuid: string){
    this.widgetId = widgetId;
    this.url = url;
    this.referer = referer;
    this.deviceCode = deviceCode;
    this.uuid = uuid;
  }

  /**
   * article.htmlのクエリパラメータに設定するkey
   * @return {string}
   */
  static QUERY_KEY(): string{
    return "dto";
  }

  /**
   * Json文字列からオブジェクトを生成
   * @param string
   * @returns {OuterToInnerDto}
   */
  static fromStringJson(string: string): OuterToInnerDto{
    try{
      const json = JSON.parse(decodeURIComponent(string));
      return new OuterToInnerDto(json.widgetId, json.url, json.referer, json.deviceCode, json.uuid);
    } catch(e){
      throw e;
    }
  }

  /**
   * オブジェクトをJson文字列にして返却
   * @return {string}
   */
  toJsonString(): string{
    const json = {
      widgetId: this.widgetId,
      url: this.url,
      referer: this.referer,
      deviceCode: this.deviceCode,
      uuid: this.uuid
    };
    return encodeURIComponent(JSON.stringify(json));
  }

}



// WEBPACK FOOTER //
// ./src/js/model/dto/outer-to-inner-dto.js